import React, { useEffect } from 'react';
import { defaultTemplate } from 'core/hoc';
import { Loader, DatePicker, DateTimePicker } from 'core/components';

const RestockDateTemplate = ({
	t,
	viewStore: {
		loading,
		form,
		datePickerFormat,
		showScheduleRestockDate,
		setShowScheduleRestockDate,
		errorMessage,
		checkForErrors,
		onChange,
		disableSaveButton,
		scheduledRestockDate,
		showScheduledRestockDatePassNote,
	},
	parentViewStore: { editRestockDateModal },
}) => {
	useEffect(() => {
		checkForErrors();
	}, [form.$('restockDate').value]);

	if (loading) return <Loader />;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('RESTOCKDATE.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="flex--primary flex--gap--4 flex--align--bottom spc--bottom--med">
						{showScheduledRestockDatePassNote && (
							<div className="message message--primary message--primary--info">
								{t('RESTOCKDATE.SCHEDULERESTOCKDATEPASSNOTE', { scheduledRestockDate: scheduledRestockDate })}
							</div>
						)}
						<div className="flex--grow--1">
							<DatePicker field={form.$('restockDate')} format={datePickerFormat} />
						</div>
						<div>
							<button
								type="button"
								className="btn btn--med btn--primary"
								onClick={() => {
									setShowScheduleRestockDate(!showScheduleRestockDate);
								}}
								title={t('RESTOCKDATE.SCHEDULE')}
							>
								<i className="fa fa-solid fa-clock spc--right--sml"></i>
								{t('RESTOCKDATE.SCHEDULE')}
							</button>
						</div>
					</div>
					{showScheduleRestockDate && (
						<div className="spc--bottom--sml">
							<DateTimePicker
								field={form.$('scheduledRestockDate')}
								minDate={new Date()}
								errorMessage={errorMessage}
								onChange={onChange}
							/>
						</div>
					)}
				</div>
				<div className="ReactModal__footer">
					<button
						className="btn btn--med btn--primary spc--right--tny spc--bottom--sml"
						type="submit"
						disabled={disableSaveButton}
					>
						{t('SAVE')}
					</button>
					<button className="btn btn--med btn--outline spc--bottom--sml" onClick={() => editRestockDateModal.close()}>
						{t('CANCEL')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(RestockDateTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/restock-date/RestockDateTemplate.jsx